import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';
import { useI18N } from '@/shared/legacy/lib/use-i18n';
import BaseTooltip from '@/shared/legacy/ui/base-tooltip/base-tooltip.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: true
},
  __name: 'hide-button',
  setup(__props) {



const i18n = useI18N();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseTooltip, {
    distance: 5,
    placement: "bottom-end"
  }, {
    default: _withCtx(({ trigger }) => [
      _createElementVNode("div", {
        ref: trigger,
        class: _normalizeClass(_ctx.$style.hideButton)
      }, [
        _createVNode(BaseIcon, _mergeProps({
          class: _ctx.$style.hideButtonIcon,
          type: "x-close"
        }, _ctx.$attrs), null, 16, ["class"])
      ], 2)
    ]),
    content: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(i18n)('hide')), 1)
    ]),
    _: 1
  }))
}
}

})